import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls window to top on route change.
 * If the URL contains a hash (e.g. /#rate-calculator), scrolls to that element instead.
 * Retries briefly to handle lazy-loaded routes where the anchor mounts after navigation.
 * Mounted once inside <BrowserRouter> in App.js.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    const id = hash.replace('#', '');
    let attempts = 0;
    const maxAttempts = 30; // ~3s @ 100ms intervals — covers lazy-loaded route mount
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (attempts < maxAttempts) {
        attempts += 1;
        setTimeout(tryScroll, 100);
      } else {
        window.scrollTo(0, 0);
      }
    };
    tryScroll();
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
